export const COMPLAINTS_TRANSLATE = {
    complaints: {
        breadcrumbName: "Denuncias",
        new: { breadcrumbName: "Nueva" },
        womanChannel: { breadcrumbName: "Canal de la Mujer" },
        messages: {
            loadingMessage: "Por favor espere, analizando seguridad de los archivos…",
            conclude: "Análisis de denuncia completado exitosamente",
            sendToAnalysis: "Análisis de denuncia iniciado",
            enableMessageFromComplainant: "Comentarios del denunciante habilitados exitosamente",
            disableMessageFromComplainant: "Comentarios del denunciante deshabilitados exitosamente",
            notFound: "Denuncia no encontrada",
            chooseCategory: "Denuncia clasificada exitosamente"
        },
        params: {
            you: "Usted",
            complainant: "Denunciante",
            committees: "Comité de análisis"
        },

        create: {
            confirmDialog: {
                title: "¡Atención!",
                body: '¿Desea confirmar el envío de esta denuncia?',
                back: {
                    text: "Cerrar",
                },
                save: {
                    text: "Sí, confirmar"
                }
            },
            helpDialog: {
                title: "¿Necesita ayuda?"
            }
        },

        afterCreate: {
            title: "Su denuncia ha sido enviada",
            imageAlt: "Logo del canal de ética",
            message: "Este es su número de protocolo. Anótelo y guárdelo en un lugar seguro, ya que es la única forma de seguir su denuncia."
        },

        noResults: {
            label: "Aún no hay ningún comentario en esta denuncia"
        },
        list: {
            table: {
                columns: {
                    protocolNumber: "Protocolo",
                    category: "Categoría",
                    createdAt: "Creado el",
                    status: "Estado",
                    id: "ID",
                }
            },
            filters: {
                fields: {
                    protocolNumber: {
                        label: "N° de protocolo",
                        placeholder: "Ingrese el número de protocolo",
                        url: "protocol-number"
                    },
                    category: {
                        label: "Categoría",
                        placeholder: "Seleccione la categoría",
                        url: "category"
                    },
                    complaintType: {
                        label: "Canal",
                        placeholder: "Seleccione el canal",
                        url: "channel"
                    },
                    status: {
                        label: "Estado",
                        placeholder: "Seleccione el estado",
                        url: "status"
                    },
                }
            }
        },

        confirmAction: {
            title: "¡Atención!",
            message: '¿Desea confirmar el envío del comentario "{{message}}"? Este comentario será visible para el denunciante y no podrá ser modificado.',
            alternativeMessage: "¿Desea confirmar el envío del comentario \"{{message}}\"? Este comentario NO será visible para el denunciante y NO podrá ser modificado.",
            complainantMessage: "¿Desea confirmar el envío del comentario \"{{message}}\"? Este comentario NO podrá ser eliminado después del envío",
            back: {
                text: "Cerrar",
            },
            save: {
                text: "Sí, confirmar"
            }
        },

        actions: {
            new: {
                text: "Hacer una denuncia"
            },
            womanChannel: {
                text: "Canal de la mujer"
            },
            choiceHelpDialog: {
                text: "¿No sabe cuál elegir?"
            },
            followUpComplaints: {
                text: "Seguir mi denuncia"
            },
            enableComplainantToAnswer: {
                text: "Permitir comentarios del denunciante"
            },
            disableComplainantToAnswer: {
                text: "Bloquear comentarios del denunciante"
            },
            exportPdf: {
                text: "Exportar PDF"
            },
            help: {
                text: "Ayuda"
            }
        },
        tabs: {
            general: "General",
            asks: "Información adicional"
        },
        save: {
            form: {
                actions: {
                    save: {
                        text: "Enviar denuncia"
                    }
                },
                fields: {
                    attachments: {
                        label: "Adjuntos",
                        noResults: {
                            label: "Aún no ha agregado ningún adjunto",
                            description: "",
                            action: {
                                label: "Agregar adjunto"
                            }
                        }
                    },
                    categoryId: {
                        label: "Tipo de denuncia",
                        placeholder: "Seleccione el tipo de denuncia"
                    },
                    description: {
                        label: "Describa su denuncia",
                        placeholder: ""
                    },
                    text: {
                        label: "Comentario",
                        placeholder: ""
                    },
                    visibleForComplaint: {
                        label: "Visible para el denunciante",
                        tooltip: "Este comentario será visible para el denunciante al consultar la denuncia"
                    }
                }
            }
        },

        single: {
            breadcrumbName: "Seguimiento",
            confirmActions: {
                sendToAnalysis: {
                    title: "¡Atención!",
                    body: '¿Desea iniciar el tratamiento de la denuncia con el protocolo {{protocol}}?',
                    back: {
                        text: "Cerrar",
                    },
                    save: {
                        text: "Sí, confirmar"
                    }
                },

                conclude: {
                    title: "¡Atención!",
                    body: '¿Desea concluir el tratamiento de la denuncia con el protocolo {{protocol}}?',
                    back: {
                        text: "Cerrar",
                    },
                    save: {
                        text: "Sí, confirmar"
                    }
                },
                allowComplainant: {
                    title: "¡Atención!",
                    body: '¿Desea permitir que el denunciante envíe comentarios?',
                    back: {
                        text: "Cerrar",
                    },
                    save: {
                        text: "Sí, confirmar"
                    }
                },
                disableComplainant: {
                    title: "¡Atención!",
                    body: '¿Desea deshabilitar al denunciante para enviar comentarios?',
                    back: {
                        text: "Cerrar",
                    },
                    save: {
                        text: "Sí, confirmar"
                    }
                },

                chooseCategory: {
                    title: "¡Atención!",
                }
            },
            fields: {
                description: "Descripción",
                protocolNumber: "Número de protocolo",
                createdAt: "Creado el",
                category: "Categoría",
                status: "Estado de la denuncia",
                attachments: "Adjuntos"
            },
            actions: {
                conclude: {
                    text: "Concluir",
                },
                start: {
                    text: "Iniciar"
                },
                exportPdf: {
                    text: "Exportar PDF"
                },
                chooseCategory: {
                    text: "Clasificar"
                }
            }
        },
        followUp: {
            breadcrumbName: "Seguimiento",
            title: "Ingrese el número de protocolo para seguir su denuncia",
            form: {
                fields: {
                    protocol: {
                        label: "Número de protocolo",
                        placeholder: "Ingrese aquí el número de protocolo"
                    }
                }
            }
        },
        investigationSteps: {
            noResults: {
                label: "Aún no hay ningún comentario en esta denuncia"
            },
            params: {
                visibleForComplainant: "Visible para el denunciante"
            }
        },
        choiceHelpDialog: {
            title: "¿Cuál debo elegir?"
        },
        asks: {
            params: {
                answer: "R:"
            }
        },
        exportComplaints: {
            title: "Exportar",
            subtitle: "Elija a continuación si desea exportar con o sin respuestas:",
            options: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                1: "Con respuestas",
                // eslint-disable-next-line @typescript-eslint/naming-convention
                2: "Sin respuestas",
            },
            save: {
                text: "Exportar"
            },
            back: {
                text: "Volver"
            },
        },
    }
}
